import { PredefinedBranchVariable } from "./branch-settings.interface";

export const BRANCH_COUNTRY_VARIABLE_NAME = "branchCountry";

export const PREDEFINED_BRANCH_VARIABLES: PredefinedBranchVariable[] = [
  { name: "branchName", label: "branchSettings.variableLabels.branchName" },
  {
    name: "branchAddress",
    label: "branchSettings.variableLabels.branchAddress",
  },
  { name: "branchCity", label: "branchSettings.variableLabels.branchCity" },
  {
    name: "branchPostalCode",
    label: "branchSettings.variableLabels.branchPostalCode",
  },
  {
    name: BRANCH_COUNTRY_VARIABLE_NAME,
    label: "branchSettings.variableLabels.branchCountry",
  },
  { name: "branchPhone", label: "branchSettings.variableLabels.branchPhone" },
  { name: "branchMail", label: "branchSettings.variableLabels.branchMail" },
];

export const PREDEFINED_BRANCH_VARIABLE_NAMES = PREDEFINED_BRANCH_VARIABLES.map(
  (variable) => variable.name,
);

export function isPredefinedBranchVariable(name: string): boolean {
  return PREDEFINED_BRANCH_VARIABLE_NAMES.includes(name);
}
